// js/ui/LevelSelect.js
// 選關畫面：依進度解鎖、顯示星級，並提供存檔碼匯入／匯出。
// 每頁顯示五關，支援分頁。

const PAGE_SIZE = 5;

import { LEVELS } from '../data/levels.js';
import { Storage } from '../core/Storage.js';

export class LevelSelect {
  constructor(root, { onPlay, onBack } = {}) {
    this.root = root;
    this.onPlay = onPlay;
    this.onBack = onBack;
    this.page = 0;
    this.el = document.createElement('div');
    this.el.className = 'screen hidden';
    this.root.appendChild(this.el);
  }

  show(state) {
    this.state = state || Storage.load();
    this._render();
    this.el.classList.remove('hidden');
  }

  hide() {
    this.el.classList.add('hidden');
  }

  refresh(state) {
    this.state = state;
    if (!this.el.classList.contains('hidden')) this._render();
  }

  _isUnlocked(idx) {
    if (idx === 0) return true;
    const prev = LEVELS[idx - 1];
    const rec = this.state.levels[prev.id];
    return !!(rec && rec.completed);
  }

  _render() {
    // 分頁：每頁十關
    const totalPages = Math.max(1, Math.ceil(LEVELS.length / PAGE_SIZE));
    this.page = Math.max(0, Math.min(this.page, totalPages - 1));
    const start = this.page * PAGE_SIZE;
    const pageLevels = LEVELS.slice(start, start + PAGE_SIZE);

    const rows = pageLevels.map((lv, i) => {
      const gi = start + i; // 全域索引（解鎖與編號用）
      const unlocked = this._isUnlocked(gi);
      const rec = this.state.levels[lv.id] || { stars: 0 };
      const stars = '★'.repeat(rec.stars || 0);
      const empties = `<span class="empty">${'★'.repeat(3 - (rec.stars || 0))}</span>`;
      return `
        <div class="level-row ${unlocked ? '' : 'locked'}" data-id="${lv.id}" data-idx="${gi}">
          <span class="num">${unlocked ? (gi + 1) : '🔒'}</span>
          <span class="title">${unlocked ? lv.name : '未解鎖'}</span>
          <span class="stars">${stars}${empties}</span>
        </div>`;
    }).join('');

    this.el.innerHTML = `
      <div class="dialog pixbox">
        <div class="dialog-header">
          <h1>黎先生：準時返工</h1>
          <button class="btn secondary" id="ls-back">返回</button>
        </div>
        <p class="sub">規劃路線、避開人潮、準時打卡。完成關卡解鎖下一張路線。</p>
        <div class="level-list">${rows}</div>
        <div class="row-btns level-pager">
          <button class="btn secondary" id="ls-prev" ${this.page === 0 ? 'disabled' : ''}>上一頁</button>
          <span class="pager-info">第 ${this.page + 1} / ${totalPages} 頁</span>
          <button class="btn secondary" id="ls-next" ${this.page >= totalPages - 1 ? 'disabled' : ''}>下一頁</button>
        </div>

        <h2>進度備份（存檔碼）</h2>
        <p class="sub">匯出目前的進度，或在新設備貼入存檔碼還原。</p>
        <textarea class="code-area" id="ls-export" readonly rows="2">${Storage.exportCode(this.state)}</textarea>
        <div class="row-btns">
          <button class="btn secondary" id="ls-copy">複製存檔碼</button>
          <button class="btn secondary" id="ls-toggle-import">匯入存檔碼…</button>
        </div>
        <div id="ls-import-wrap" class="hidden" style="margin-top:10px">
          <textarea class="code-area" id="ls-import" rows="2" placeholder="貼上存檔碼…"></textarea>
          <div class="row-btns">
            <button class="btn" id="ls-do-import">還原進度</button>
          </div>
        </div>
        <div id="ls-toast" class="toast hidden"></div>
      </div>
    `;

    this.el.querySelector('#ls-back').onclick = () => this.onBack && this.onBack();
    this.el.querySelector('#ls-prev').onclick = () => { this.page--; this._render(); };
    this.el.querySelector('#ls-next').onclick = () => { this.page++; this._render(); };
    this.el.querySelectorAll('.level-row').forEach((row) => {
      row.onclick = () => {
        const idx = parseInt(row.dataset.idx, 10);
        if (!this._isUnlocked(idx)) return;
        if (this.onPlay) this.onPlay(row.dataset.id);
      };
    });

    this.el.querySelector('#ls-toggle-import').onclick = () => {
      const w = this.el.querySelector('#ls-import-wrap');
      w.classList.toggle('hidden');
    };
    this.el.querySelector('#ls-copy').onclick = () => {
      const code = this.el.querySelector('#ls-export').value;
      this._copy(code).then((ok) => this._toast(ok ? '已複製到剪貼簿' : '複製失敗，請手動選取'));
    };
    this.el.querySelector('#ls-do-import').onclick = () => {
      const code = this.el.querySelector('#ls-import').value.trim();
      try {
        const incoming = Storage.importCode(code);
        this.state = Storage.merge(this.state, incoming);
        Storage.save(this.state);
        this._render();
        this._toast('進度已還原');
      } catch (e) {
        this._toast('匯入失敗：' + e.message);
      }
    };
  }

  _toast(msg) {
    const t = this.el.querySelector('#ls-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.remove('hidden');
    clearTimeout(this._tt);
    this._tt = setTimeout(() => t.classList.add('hidden'), 2000);
  }

  _copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
    }
    return Promise.resolve(false);
  }
}
